import { Injectable, OnInit } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RoutesRecognized } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
declare var $: any;
import jwtDecode from 'jwt-decode'; import { environment } from 'src/environments/environment';
'jwt-decode';

@Injectable()
export class CommonService implements OnInit, CanActivate, CanActivateChild {
  JwtToken: string = "";
  Token: string = "";
  UserId: number = 0;
  facultyid: number = 0;
  UserName: string = "";
  CurrentTime: string = "";
  //baseroot: string = "https://teacherapis.hitbullseye.com/api/";
  baseroot: string = environment.apiurl;// "http://localhost:62892/api/";
  menuroute: string = "";
  restrictedids: string = "";
  LoginLogId: number = 0;
  canperr: number = 0;
  constructor(private LocalStorage: LocalStorageService, private route: Router, private http: HttpClient) {



  }
  ngOnInit() {
    this.Token = this.LocalStorage.get('Token');
    this.UserName = this.LocalStorage.get('LoginUserName');
    this.JwtToken = jwtDecode(this.LocalStorage.get("Token"));
    this.facultyid = this.LocalStorage.get("facultyid");
    this.canperr = this.LocalStorage.get("canperr");
    let givenName: any = jwtDecode(this.LocalStorage.get("Token"));

    this.UserId = parseInt(givenName['unique_name']);
    this.LoginLogId = parseInt(givenName['LoginLogId']);
    console.log("service working")

  }
  GetToken() {
    return this.Token;
  }
  GetUser() {
    return this.UserId;
  }
  canaddresources() {
    return this.canperr;
  }
  GetFacultyid() {
    return this.facultyid;
  }
  Checkstorageavailable() {
    if (this.LocalStorage.get('Token') == undefined) {
      this.route.navigate(['auth/login']);
      return false;
    }
    else {
      return true;
    }
  }
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

    if (route.url.toString() == "add-resources" && this.LocalStorage.get("canperr") == 0) {
      return of(false);
    }
    else {
      return of(true);
    }
  }
  canActivateChild() {

    if (this.LocalStorage.get("Token") == null || this.LocalStorage.get("Token") == undefined) {
      this.LocalStorage.clearAll();
      this.route.navigate(['auth/login']);
      return false
    }
    else {
      return true
    }
  }
  logout(Token: any, UserId: any, Reason: any) {
    this.LocalStorage.clearAll();
    this.route.navigate(['auth/login']);
  }
}
